const Envelope = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      viewBox="0 0 20 16"
    >
      <g fill="none" fillRule="evenodd">
        <g fill="#4F4335" fillRule="nonzero">
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="M2 0C.897 0 0 .897 0 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2H2zm0 2h16v.006L10 7 2 2.004V2zm0 2.004L10 9l8-4.994.002 9.994H2V4.004z"
                    transform="translate(-733 -452) translate(165 294) translate(534 123) translate(34 34) translate(0 1)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export { Envelope };
